import { Button as DevButton } from 'devextreme-react/button';
import { LoadIndicator } from 'devextreme-react/load-indicator';
import React, { useState } from "react";
import { useSelector } from 'react-redux';
import { phanBoPhiApi } from "../../../api/phanBoPhiApi";
import { showNotify } from "../../../helpers/toast";
import { ts_hocsinh } from "../../../models/response/hocsinh/ts_hocsinh";
import { sf_mucphaithu } from "../../../models/response/thu-phi/sf_mucphaithu";
import { RootState } from '../../../state/reducers';
import SendBienLaiModal from '../send-bien-lai/SendBienLaiModal';

type ThuPhiFinishConfirmBtnProps = {
    disabled: boolean,
    sf_mucphaithu: sf_mucphaithu,
    ts_hocsinh: ts_hocsinh,
    onChanged: () => void | Promise<void>,
    ngaythu: any,
    nam_hoc_dong_phi: string
}

const ThuPhiFinishConfirmBtn = (props: ThuPhiFinishConfirmBtnProps) => {
    const state = useSelector((x: RootState) => x.thuPhiChiTiet)
    const {
        sf_phanbophis
    } = state;
    const [isSaving, setIsSaving] = useState<boolean>(false)
    const [isShowSendEmailModal, setIsShowSendEmailModal] = useState<boolean>(false)
    const is_chuyenkhoan = sf_phanbophis !== undefined && sf_phanbophis !== null && sf_phanbophis.length > 0 && sf_phanbophis[0].hinh_thuc_thanh_toan.toUpperCase().includes("CHUYỂN KHOẢN");
    
    const handleSubmit = async () => {
        setIsSaving(true)
        const res = await phanBoPhiApi.save_finish(props.sf_mucphaithu.id, props.ngaythu, props.nam_hoc_dong_phi);
        if (res.is_success) {
            showNotify({ message: "Thành công", type: "success" });
            await props.onChanged()
            setIsShowSendEmailModal(true);
        } else {
            showNotify({ message: res.message || "Thất bại", type: "error" });
        }
        setIsSaving(false)
    }

    return (
        <>
            <DevButton
                text="Lưu"
                type="normal"
                stylingMode="text"
                icon="todo"
                className="p-btn-devextreme"
                disabled={props.disabled || isSaving}
                onClick={handleSubmit}
            >
                {isSaving && <LoadIndicator width={20} height={20} visible={true} />}
            </DevButton>
            {isShowSendEmailModal && is_chuyenkhoan &&
                <SendBienLaiModal
                    onClose={() => {
                        setIsShowSendEmailModal(false);
                    }}
                    sf_mucphaithu={props.sf_mucphaithu}
                    ts_hocsinh_id={props.ts_hocsinh.id}
                />
            }

        </>
    )
}
export default ThuPhiFinishConfirmBtn